import { en, de, fr, lb } from '@formkit/i18n'
import '@formkit/themes/genesis'
import { genesisIcons } from '@formkit/icons'
import { createFloatingLabelsPlugin } from '@formkit/addons'
import { createI18nPlugin } from '@formkit/i18n'
import { generateClasses } from "@formkit/themes";

const config = {
    locales: { en, de, fr, lb },
    locale: 'en',
    theme: 'genesis',
    icons: {
        genesisIcons
    },
    classes: generateClasses({
        global: {
            label: 'zustand1'
        }
    }),
    plugins: [
        createFloatingLabelsPlugin( {
            useAsDefault: false,
        }),
        createI18nPlugin( { en, de, fr, lb }),
    ],
}

export default config